import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useAuth } from '@/AuthContext'; // Ensure this is the correct path
const Callback = () => {
    const { exchangeCodeForToken, fetchUserInfo, setShowPopup } = useAuth(); // Get fetchUserInfo and setShowPopup from context
    useEffect(() => {
        // Extract the authorization code from the URL
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if (code) {
            // Call the exchangeCodeForToken function with the authorization code
            exchangeCodeForToken(code, setShowPopup) // Pass setShowPopup as the second argument
                .then(() => {
                fetchUserInfo(() => {
                    window.location.href = '/'; // Redirect to the chat page on success
                }, () => {
                    console.error('Failed to fetch user info after token exchange'); // Handle error case
                }, setShowPopup // Pass setShowPopup to handle errors
                );
            })
                .catch(error => {
                console.error('Error during token exchange:', error); // Log any errors
            });
            // Clear the authorization code from the URL
            window.history.replaceState({}, document.title, window.location.pathname);
        }
        else {
            console.error('No authorization code found in the URL.');
        }
    }, [exchangeCodeForToken, fetchUserInfo, setShowPopup]);
    return _jsx("div", { children: "Loading..." }); // Show loading state while processing
};
export default Callback;
